// extracted by mini-css-extract-plugin
export default {"icons":"Home_icons__S7biV","name":"Home_name__1Ow0r","deg":"Home_deg__8XdTo","btn":"Home_btn__HC20W"};